/**
 * 台账设备接口
 */
import Axios from '@/components/api/axios.js'

export default {
	/***********************************************************************************************************************台账查询*/
	/**
	 * 查询台账设备树
	 */
	getArchivesTree(success, failure) {
		Axios.post('/archives/getArchivesTree.do', {}, success, failure)
	},
	/**
	 * 查询设备台账属性
	 * @param {String} ids 台账id集合，多个用逗号隔开
	 */
	getArchivesInfoByIds(ids, success, failure) {
		Axios.post('/archives/getArchivesInfoByIds.do', {
			ids
		}, success, failure)
	},
	/***********************************************************************************************************************台账基本业务*/
	/**
	 * 添加或更新台账信息
	 * @param {json} property 台账属性值，json格式
	 */
	saveArchives(pkid, name, typeCode, groupId, sort, property, success, failure) {
		Axios.post('/archives/saveArchives.do', {
			pkid,
			name,
			typeCode,
			groupId,
			sort,
			property
		}, success, failure)
	},
	/**
	 * 根据台账id删除台账设备信息（包括属性值）
	 */
	deleteArchives(pkid, success, failure) {
		Axios.post('/archives/deleteArchives.do', {
			pkid
		}, success, failure)
	},
	/**
	 * 快速创建台账信息（克隆）
	 */
	copyArchivesInfoById(archivesId, success, failure) {
		Axios.post('/archives/copyArchivesInfoById.do', {
			archivesId
		}, success, failure)
	},
	/***********************************************************************************************************************台账查询过滤*/
	/**
	 * 通过台账设备属性编码和属性值称过滤台账设备，不可模糊查询
	 * @param {String} typePropertyCode 属性编码
	 * @param {String} value 属性值
	 */
	getDeviceInfoByPropertyValue(typeCode, typePropertyCode, value, success, failure) {
		Axios.post('/archives/getDeviceInfoByPropertyValue.do', {
			typeCode,
			typePropertyCode,
			value
		}, success, failure)
	},
	/**
	 * 通过台账设备属性编码和属性值称过滤台账设备，不可模糊查询,不会做按用户权限过滤的,查询所有
	 * @param {String} typePropertyCode 属性编码
	 * @param {String} value 属性值
	 */
	getDeviceInfoByPropertyValueWithNoToken(typeCode, typePropertyCode, value, success, failure) {
		Axios.post('/archives/getDeviceInfoByPropertyValueWithNoToken.do', {
			typeCode,
			typePropertyCode,
			value
		}, success, failure)
	},
	/**
	 * 通过台账设备名称过滤台账设备
	 * @param {String} archivesName 可模糊查询
	 */
	getDeviceInfoLikeArchivesName(archivesName, success, failure) {
		Axios.post('/archives/getDeviceInfoLikeArchivesName.do', {
			archivesName
		}, success, failure)
	},
	/***********************************************************************************************************************台账关联关系*/
	/**
	 * 绑定虚拟设备
	 */
	bindVirtualDevice(archivesId, deviceNo, success, failure) {
		Axios.post('/archives/bindVirtualDevice.do', {
			archivesId,
			deviceNo
		}, success, failure)
	},
	/**
	 * 绑定虚拟设备组
	 */
	bindVirtualGroup(archivesId, classNo, success, failure) {
		Axios.post('/archives/bindClassType.do', {
			archivesId,
			classNo
		}, success, failure)
	},
	/**
	 * 解绑台账设备相关关系
	 */
	unbindByArchivesId(archivesId, success, failure) {
		Axios.post('/archives/unbindByArchivesId.do', {
			archivesId
		}, success, failure)
	},
	/**
	 * 通过虚拟设备组no解绑所关联的台账设备
	 */
	unbindArchivesByAppClassTypeNo(classNo, success, failure) {
		Axios.post('/archives/unbindArchivesByAppClassTypeNo.do', {
			classNo
		}, success, failure)
	},
	/**
	 * 通过虚拟设备no解绑所关联的台账设备
	 */
	unbindArchivesByVirtualDeviceNo(deviceNo, success, failure) {
		Axios.post('/archives/unbindArchivesByVirtualDeviceNo.do', {
			deviceNo
		}, success, failure)
	},
	/**
	 * 通过虚拟设备组no批量查询对应的台账设备及其属性值
	 */
	getArchivesInfoByVirtualGroupNos(nos, success, failure) {
		Axios.post('/archives/getArchivesInfoByVirtualGroupNos.do', {
			nos
		}, success, failure)
	},
	/**
	 * 通过虚拟设备组no批量查询对应的台账设备及其属性值
	 */
	getArchivesInfoByVirtualDeviceNos(nos, success, failure) {
		Axios.post('/archives/getArchivesInfoByVirtualDeviceNos.do', {
			nos
		}, success, failure)
	},

	/**通过台账设备ID列表查询对应绑定的虚拟设备或者组信息
	 * @param {Object} archivesIds
	 * @param {Object} success
	 * @param {Object} failure
	 */
	getVirtualInfoByArchivesIds(archivesIds, success, failure) {
		Axios.post('/archives/getVirtualInfoByArchivesIds.do', {
			archivesIds
		}, success, failure)
	},
	/***********************************************************************************************************************台账导出导入*/
	/**导出指定单位指定类型的所有台账设备列表，需要指定文件名称
	 * @param {Object} fileName 文件名称
	 * @param {Object} groupNo 组no
	 * @param {Object} entityTypeCode 模板类型
	 * @param {Object} success
	 * @param {Object} failure
	 */
	exportArchivesInfo(fileName, groupNo, entityTypeCode, success, failure) {
		Axios.post('/archives/exportArchivesInfo.do', {
			fileName,
			groupNo,
			entityTypeCode
		}, success, failure)
	},
	/**导出指定单位指定类型的台账台账导入模板，需要指定文件名称
	 * @param {Object} fileName 文件名称
	 * @param {Object} groupNo 组no
	 * @param {Object} entityTypeCode  模板类型
	 * @param {Object} success
	 * @param {Object} failure
	 */
	exportImportTemplate(fileName, groupNo, entityTypeCode, success, failure) {
		Axios.post('/archives/exportImportTemplate.do', {
			fileName,
			groupNo,
			entityTypeCode
		}, success, failure)
	},
	/**导入台账信息
	 * @param {Object} resourcesId 上传资源id
	 */
	importArchivesInfo(resourcesId, success, failure) {
		Axios.post('/archives/importArchivesInfo.do', {
			resourcesId
		}, success, failure)
	},
	/** 获取第一层台账模板列表
	 */
	getFirstEntityTypeList(success, failure) {
		Axios.post('/entity/getFirstEntityTypeList.do', {}, success, failure)
	},
	/** 获取指定模板下子模板以及属性值树
	 */
	getEntityAndPropertyTree(typeCode, success, failure) {
		Axios.post('/entity/getEntityAndPropertyTree.do', {
			typeCode
		}, success, failure)
	},
	/** 获取台账设备的属性值列表
	 */
	getPropertyValueTree(archivesId, success, failure) {
		Axios.post('/archives/getPropertyValueTree.do', {
			archivesId
		}, success, failure)
	},
	/** 添加台账设备
	 */
	saveArchivesInfo(archivesInfo, success, failure) {
		Axios.post('/archives/saveArchivesInfo.do', {
			archivesInfo
		}, success, failure)
	},
	/** 查询当前组的台账信息
	 */
	getArchivesList(groupNo,pageIndex,pageSize,success, failure) {
		Axios.post('/archives/getArchivesList.do', {
			groupNo,
			pageIndex,
			pageSize,
		}, success, failure)
	},
	/** 
	 * 通过typeCode查询台账
	 */
	getArchivesListByTypeCode(typeCode,success, failure) {
		Axios.post('/archives/getArchivesListByTypeCode.do', {
			typeCode
		}, success, failure)
	},

	/**
	 * 通过typeCode和groupNo查询台账
	 *
	 */
	getArchivesListByTypeCodeAndGroupNo(typeCode,groupNo,success, failure) {
		Axios.post('/archives/getArchivesListByTypeCode.do', {
			typeCode,groupNo
		}, success, failure)
	},


	/** 
	 * 通过groupNo,name 下载设备信息文件
	 */
	getQRCodeAppEquipInfo(groupNo,name, success, failure) {
		Axios.get('/archives/getQRCodeAppEquipInfo.do', {
			groupNo,
			name,
		}, success, failure)
	},
}